import { render, staticRenderFns } from "./TrademarkSearchForm.vue?vue&type=template&id=784af4ac&"
import script from "./TrademarkSearchForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchForm.vue?vue&type=style&index=0&id=784af4ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports